module.exports = __webpack_public_path__ + "media/src/images/icons/car-fe0445bc2f0747d184d00296778bb6e5.svg";